(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bestel-info-popup"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-order-popup]').forEach(function (root) {
  var dialog = root.querySelector('[data-order-popup-dialog]');
  var openBtn = root.querySelector('[data-order-popup-open]');
  var closeBtn = root.querySelector('[data-order-popup-close]');
  if (!dialog) return;

  // Versioned key: bump "Inhoudsversie" in the section settings when the
  // pickup schedule changes so returning visitors see the popup again.
  var version = root.getAttribute('data-info-version') || '1';
  var KEY = 'dzb_orderinfo_dismissed_v' + version;
  var SESSION_KEY = KEY + '_session';
  var softClose = false;

  function open() {
    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }
  }

  function remember() {
    // Backdrop click only hides for this session; explicit close (button/Esc)
    // hides until the version changes.
    try {
      if (softClose) {
        sessionStorage.setItem(SESSION_KEY, '1');
      } else {
        localStorage.setItem(KEY, '1');
      }
    } catch (e) {}
    softClose = false;
  }

  function close() {
    if (typeof dialog.close === 'function') {
      dialog.close(); // fires the 'close' event, which calls remember()
    } else {
      dialog.removeAttribute('open');
      remember();
    }
  }

  if (openBtn) openBtn.addEventListener('click', open);
  if (closeBtn) closeBtn.addEventListener('click', close);

  dialog.addEventListener('click', function (e) {
    if (e.target === dialog) {
      softClose = true;
      close();
    }
  });
  dialog.addEventListener('close', remember);

  var dismissed = null;
  try {
    dismissed = localStorage.getItem(KEY) || sessionStorage.getItem(SESSION_KEY);
  } catch (e) {}

  // Niet tegelijk met Shopify's cookiemelding openen: wacht tot die weg is (+1,5 s).
  // Verschijnt er geen melding (keuze al eerder gemaakt), dan na ~2,5 s.
  // De melding komt asynchroon in beeld, vandaar eerst even kijken voordat we besluiten.
  function whenCookieBannerGone(cb) {
    var start = Date.now();
    var sawBanner = false;
    (function check() {
      var banner = document.getElementById('shopify-pc__banner');
      var visible = !!banner && banner.getClientRects().length > 0 &&
        getComputedStyle(banner).visibility !== 'hidden';
      var waited = Date.now() - start;
      if (visible) {
        sawBanner = true;
        if (waited > 120000) return; // nooit gekozen: popup niet meer forceren
        setTimeout(check, 400);
      } else if (sawBanner) {
        setTimeout(cb, 1500);
      } else if (waited >= 2500) {
        cb();
      } else {
        setTimeout(check, 400);
      }
    })();
  }

  if (dialog.getAttribute('data-auto-open') === 'true' && !dismissed) {
    whenCookieBannerGone(function () {
      if (!dialog.open) open();
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
